<h2>Configuration Information</h2>
<div *ngIf="configInfo">
  <table border="1" width="800">
		<tr>
			<td width="20%">Build Info</td><td [innerHTML]="configInfo.buildInfo"></td>
		</tr>
		<tr>
			<td>Git Commit</td><td [innerHTML]="configInfo.gitCommit"></td>
		</tr>
		<tr>
			<td>JVM Params</td><td [innerHTML]="configInfo.jvmParams"></td>
		</tr>
		<tr>
			<td>Locale Code</td><td [innerHTML]="localeCode"></td>
		</tr>
		<tr>
			<td>App Server</td><td [innerHTML]="appServer"></td>
		</tr>
		<tr>
			<td>X-Forwarded-Proto</td><td [innerHTML]="xFwdProto"></td>
		</tr>
	</table>

</div>
